import { render, staticRenderFns } from "./checkEmail.vue?vue&type=template&id=21ef591c&scoped=true"
import script from "./checkEmail.vue?vue&type=script&lang=js"
export * from "./checkEmail.vue?vue&type=script&lang=js"
import style0 from "./checkEmail.vue?vue&type=style&index=0&id=21ef591c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ef591c",
  null
  
)

export default component.exports